/* eslint-disable @typescript-eslint/no-explicit-any */

import cx from "classnames";
import React from "react";

interface SpaceBetweenProps {
  children: any;
  spacing: string;
}

const SpaceBetween: React.SFC<SpaceBetweenProps> = ({ children, spacing }) => {
  let kids = children;
  if (children.type === React.Fragment) {
    kids = children.props.children;
  }
  if (typeof kids === "string") {
    return <>{kids}</>;
  }
  const childCount = React.Children.count(kids);
  return (
    <React.Fragment>
      {React.Children.map(
        kids,
        (child: React.ReactElement<any>, i) =>
          child &&
          React.cloneElement(child, {
            className: cx(child.props.className, { [spacing]: i !== childCount - 1 }),
          })
      )}
    </React.Fragment>
  );
};

export default SpaceBetween;
